const enquire = require('enquire.js');
const $ = require('jquery');

enquire.register('print', {
  match() {
    $('table.table-responsive').css(
      'max-width',
      `${document.body.clientWidth}px`
    );
  },
  unmatch() {
    $('table.table-responsive').css('max-width', '');
  },
});
